import type { QuizAnswers } from './types';
import type { QuestionProps } from './types';
import type { ProfileStepIds } from '@/models/recommendation';
import type { RecommendationProfile } from '@/models/recommendation';

export const isQuestionVisible = (
  question: QuestionProps,
  currentAnswers: QuizAnswers
) => !question.shouldShow || question.shouldShow(currentAnswers);

export const findNextVisibleQuestion = (
  fromIndex: number,
  questions: QuestionProps[],
  currentAnswers: QuizAnswers
): { index: number; question: QuestionProps } | null => {
  for (let i = fromIndex + 1; i < questions.length; i++) {
    if (isQuestionVisible(questions[i], currentAnswers)) {
      return { index: i, question: questions[i] };
    }
  }
  return null;
};

export const quizAnswersToProfilePayload = (
  profileId: number,
  answers: QuizAnswers,
  nextStep: ProfileStepIds
): Partial<RecommendationProfile> => {
  const filteredAnswers = Object.fromEntries(
    Object.entries(answers).filter(([, value]) => {
      if (value === null || value === undefined) return false;
      if (Array.isArray(value) && value.length === 0) return false;
      return true;
    })
  );

  return {
    id: profileId,
    current_step: nextStep,
    ...filteredAnswers,
  };
};
